import React from "react";

import style from "./style.module.css";

type ManualProps = {
  name: string;
  region: string;
  thumbnail: string;
  children: React.ReactNode;
};

function Manual({ thumbnail, name, region, children }: ManualProps) {
  return (
    <section className={style.manual}>
      <header className={style.header}>
        <img src={thumbnail} alt="House" className={style.image} />
        <div className={style.titleContainer}>
          <h2 className={style.name}>{name}</h2>
          <h4 className={style.region}>{region}</h4>
        </div>
      </header>
      <div className={style.content}>
        <div className={style.contentBody}>{children}</div>
      </div>
    </section>
  );
}

export default Manual;
